import { makeStyles } from "@material-ui/core";

const useRbFlexViewStyles = makeStyles({
  root: (props) => ({
    display: "flex",
    flexDirection: props.direction,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
  }),
});

export default useRbFlexViewStyles;
